function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Button, Drawer, List, message, Tabs, Alert, Space, Modal, Typography } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import { CalendarPlusFill, ListTask, ShareFill, TrashFill, ArrowCounterclockwise, PencilSquare, CheckSquareFill, CalendarMinus, BellFill, BellSlashFill } from 'react-bootstrap-icons';
import AddTask from '../components/forms/AddTask';
import Common from '../components/includes/Common';
import Moment from 'react-moment';
import EditTask from '../components/forms/EditTask';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Text = Typography.Text;
var confirm = Modal.confirm;
var ToDo = function ToDo() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewTaskVisible = _useState2[0],
    setIsNewTaskVisible = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataChanged = _useState4[0],
    setIsDataChanged = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    myTaskList = _useState8[0],
    setMyTaskList = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    myAssignedTaskList = _useState0[0],
    setMyAssignedTaskList = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isFormLoading = _useState10[0],
    setIsFormLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isEditTaskVisible = _useState12[0],
    setIsEditTaskVisible = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedTask = _useState14[0],
    setSelectedTask = _useState14[1];
  var handleTaskDone = function handleTaskDone(task) {
    setSelectedTask(task);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La validation de la tache - ", task.label]
      }),
      onOk: function onOk() {
        setIsFormLoading(true);
        axios.post(Common.baseApiUrl + 'settaskvalidated', {
          task_id: task.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setIsDataChanged(true);
            message.success({
              content: "La tache à été validée",
              delay: 4
            });
          } else {
            setFormError(response.data.message);
          }
        })["catch"](function (error) {
          setFormError('Une erreur est survenue');
        })["finally"](function () {
          setIsFormLoading(false);
        });
      }
    });
  };
  var handleTaskUndo = function handleTaskUndo(task) {
    setSelectedTask(task);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Souhaitez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Remettre la tache - ", task.label]
      }),
      onOk: function onOk() {
        setIsFormLoading(true);
        axios.post(Common.baseApiUrl + 'undotask', {
          task_id: task.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setIsDataChanged(true);
            message.success({
              content: "La tache à été remise à nouveau",
              delay: 4
            });
          } else {
            setFormError(response.data.message);
          }
        })["catch"](function (error) {
          setFormError('Une erreur est survenue');
        })["finally"](function () {
          setIsFormLoading(false);
        });
      }
    });
  };
  var handleDeleteTask = function handleDeleteTask(task) {
    setSelectedTask(task);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La supression de la taches - ", task.label]
      }),
      onOk: function onOk() {
        setIsFormLoading(true);
        axios.get("".concat(Common.baseApiUrl, "deletetask/").concat(task.id, "/").concat(Common.currentUser.id)).then(function (response) {
          if (response.data.status == 200) {
            setIsDataChanged(true);
            message.success({
              content: "La tache à été supprimée",
              delay: 4
            });
          } else {
            setFormError(response.data.message);
          }
        })["catch"](function (error) {
          setFormError('Une erreur est survenue');
        })["finally"](function () {
          setIsFormLoading(false);
        });
      }
    });
  };
  var handleEdit = function handleEdit(task) {
    setSelectedTask(task);
    setIsEditTaskVisible(true);
  };
  var TabsContent = [{
    key: 1,
    label: /*#__PURE__*/_jsxs("b", {
      children: [" ", /*#__PURE__*/_jsx(ListTask, {
        size: 22
      }), " Mes taches \xE0 venir"]
    }),
    children: /*#__PURE__*/_jsx("div", {
      style: {
        padding: "8px"
      },
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 6,
          md: 6,
          style: {
            borderRight: '1px solid #DBB100'
          },
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "MES TACHES PERSONNELLES"
            })
          }), /*#__PURE__*/_jsx(List, {
            loading: isDataLoading,
            dataSource: myTaskList.filter(function (t) {
              return t.status == 0;
            }),
            itemLayout: "vertical",
            renderItem: function renderItem(item) {
              return /*#__PURE__*/_jsx(List.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  message: /*#__PURE__*/_jsx("b", {
                    children: item.label
                  }),
                  description: /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx("p", {
                      children: item.description
                    }), /*#__PURE__*/_jsx("span", {
                      children: /*#__PURE__*/_jsxs("b", {
                        children: [/*#__PURE__*/_jsx(CalendarMinus, {
                          size: 18
                        }), " Deadline : ", /*#__PURE__*/_jsx(Moment, {
                          date: item.planned_date,
                          format: "DD/MM/YYYY"
                        }), " ", item.remind == 1 ? /*#__PURE__*/_jsx(BellFill, {
                          size: 18
                        }) : /*#__PURE__*/_jsx(BellSlashFill, {
                          size: 18
                        })]
                      })
                    })]
                  }),
                  type: "warning",
                  action: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: [/*#__PURE__*/_jsx(Button, {
                      size: "small",
                      type: "ghost",
                      children: /*#__PURE__*/_jsx(CheckSquareFill, {
                        onClick: function onClick() {
                          handleTaskDone(item);
                        },
                        style: {
                          color: '#63C344'
                        },
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx(Button, {
                      size: "small",
                      onClick: function onClick() {
                        handleEdit(item);
                      },
                      danger: true,
                      type: "ghost",
                      children: /*#__PURE__*/_jsx(PencilSquare, {
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx(Button, {
                      onClick: function onClick() {
                        handleDeleteTask(item);
                      },
                      size: "small",
                      danger: true,
                      type: "ghost",
                      children: /*#__PURE__*/_jsx(TrashFill, {
                        size: 20
                      })
                    })]
                  })
                })
              });
            }
          })]
        }), /*#__PURE__*/_jsxs(Col, {
          lg: 6,
          md: 6,
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "MES TACHES ASSIGNEES"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(List, {
            loading: isDataLoading,
            dataSource: myAssignedTaskList.filter(function (a) {
              return a.task != null && a.task.status == 0;
            }),
            itemLayout: "vertical",
            renderItem: function renderItem(item) {
              return /*#__PURE__*/_jsx(List.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  message: /*#__PURE__*/_jsx("b", {
                    children: item.task.label
                  }),
                  description: /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx("p", {
                      children: item.task.description
                    }), /*#__PURE__*/_jsx("span", {
                      children: /*#__PURE__*/_jsxs("b", {
                        children: [/*#__PURE__*/_jsx(CalendarMinus, {
                          size: 18
                        }), " Deadline : ", /*#__PURE__*/_jsx(Moment, {
                          date: item.task.planned_date,
                          format: "DD/MM/YYYY"
                        }), " ", item.task.remind == 1 ? /*#__PURE__*/_jsx(BellFill, {
                          size: 18
                        }) : /*#__PURE__*/_jsx(BellSlashFill, {
                          size: 18
                        })]
                      })
                    })]
                  }),
                  type: "success",
                  action: /*#__PURE__*/_jsx(Space, {
                    direction: "horizontal",
                    children: /*#__PURE__*/_jsx(Button, {
                      size: "small",
                      type: "ghost",
                      children: /*#__PURE__*/_jsx(CheckSquareFill, {
                        onClick: function onClick() {
                          handleTaskDone(item.task);
                        },
                        style: {
                          color: '#63C344'
                        },
                        size: 20
                      })
                    })
                  })
                })
              });
            }
          })]
        })]
      })
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsxs("b", {
      children: [" ", /*#__PURE__*/_jsx(ShareFill, {
        size: 22
      }), " Taches realis\xE9\xE9s"]
    }),
    children: /*#__PURE__*/_jsx("div", {
      style: {
        padding: "8px"
      },
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(List, {
            loading: isDataLoading,
            dataSource: myTaskList.filter(function (t) {
              return t.status == 1;
            }),
            itemLayout: "vertical",
            renderItem: function renderItem(item) {
              return /*#__PURE__*/_jsx(List.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  message: /*#__PURE__*/_jsx("b", {
                    children: item.label
                  }),
                  description: /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx("p", {
                      children: item.description
                    }), /*#__PURE__*/_jsx("span", {
                      children: /*#__PURE__*/_jsxs("b", {
                        children: [/*#__PURE__*/_jsx(CalendarMinus, {
                          size: 18
                        }), " Deadline : ", /*#__PURE__*/_jsx(Moment, {
                          date: item.planned_date,
                          format: "DD/MM/YYYY"
                        }), " ", item.remind == 1 ? /*#__PURE__*/_jsx(BellFill, {
                          size: 18
                        }) : /*#__PURE__*/_jsx(BellSlashFill, {
                          size: 18
                        })]
                      })
                    })]
                  }),
                  type: "warning",
                  action: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: [/*#__PURE__*/_jsx(Button, {
                      size: "small",
                      type: "ghost",
                      children: /*#__PURE__*/_jsx(ArrowCounterclockwise, {
                        onClick: function onClick() {
                          handleTaskUndo(item);
                        },
                        style: {
                          color: '#63C344'
                        },
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx(Button, {
                      onClick: function onClick() {
                        handleDeleteTask(item);
                      },
                      size: "small",
                      danger: true,
                      type: "ghost",
                      children: /*#__PURE__*/_jsx(TrashFill, {
                        size: 20
                      })
                    })]
                  })
                })
              });
            }
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(List, {
            loading: isDataLoading,
            dataSource: myAssignedTaskList.filter(function (a) {
              return a.task != null && a.task.status == 1;
            }),
            itemLayout: "vertical",
            renderItem: function renderItem(item) {
              return /*#__PURE__*/_jsx(List.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  message: /*#__PURE__*/_jsx("b", {
                    children: item.task.label
                  }),
                  description: /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx("p", {
                      children: item.task.description
                    }), /*#__PURE__*/_jsx("span", {
                      children: /*#__PURE__*/_jsxs("b", {
                        children: [/*#__PURE__*/_jsx(CalendarMinus, {
                          size: 18
                        }), " Deadline : ", /*#__PURE__*/_jsx(Moment, {
                          date: item.task.planned_date,
                          format: "DD/MM/YYYY"
                        }), " ", item.task.remind == 1 ? /*#__PURE__*/_jsx(BellFill, {
                          size: 18
                        }) : /*#__PURE__*/_jsx(BellSlashFill, {
                          size: 18
                        })]
                      })
                    })]
                  }),
                  type: "success",
                  action: /*#__PURE__*/_jsx(Space, {
                    direction: "horizontal",
                    children: /*#__PURE__*/_jsx(Button, {
                      size: "small",
                      type: "ghost",
                      children: /*#__PURE__*/_jsx(CheckSquareFill, {
                        onClick: function onClick() {
                          handleTaskDone(item.task);
                        },
                        style: {
                          color: '#63C344'
                        },
                        size: 20
                      })
                    })
                  })
                })
              });
            }
          })
        })]
      })
    })
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setIsDataChanged(false);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getusertasks/").concat(Common.currentUser.id)), axios.get("".concat(Common.baseApiUrl, "getassignedtasks/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status == 200) {
        setMyTaskList(response[0].data.tasks);
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setMyAssignedTaskList(response[1].data.tasks);
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          onClick: function onClick() {
            setIsNewTaskVisible(true);
          },
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(CalendarPlusFill, {
              size: 24
            }), " NVELLE TACHE"]
          })
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        lg: 12,
        md: 12,
        children: /*#__PURE__*/_jsx("div", {
          className: "taskCol",
          style: {
            background: '#FFFFFF',
            padding: '20px'
          },
          children: /*#__PURE__*/_jsx(Tabs, {
            animated: true,
            items: TabsContent
          })
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      width: "350px",
      title: /*#__PURE__*/_jsx("b", {
        children: "NOUVELLE TACHE"
      }),
      destroyOnClose: true,
      open: isNewTaskVisible,
      onClose: function onClose() {
        setIsNewTaskVisible(false);
      },
      children: /*#__PURE__*/_jsx(AddTask, {
        handler: function handler() {
          setIsDataChanged(true);
          setIsNewTaskVisible(false);
          message.success({
            content: "Opération réussie !",
            delay: 4
          });
        }
      })
    }), selectedTask != null && /*#__PURE__*/_jsx(Modal, {
      width: "500px",
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER LA TACHE"
      }),
      destroyOnClose: true,
      footer: null,
      open: isEditTaskVisible,
      onCancel: function onCancel() {
        setIsEditTaskVisible(false);
      },
      children: /*#__PURE__*/_jsx(EditTask, {
        task: selectedTask,
        handler: function handler() {
          setIsDataChanged(true);
          setIsEditTaskVisible(false);
          message.success({
            content: "Opération réussie",
            delay: 4
          });
        }
      })
    })]
  });
};
export default ToDo;